module.exports = __webpack_public_path__ + "static/media/3129 Echo-Parc_DSC8702.80e8fa45.jpg";